import qs from 'qs';
import ApiResourceManager from '../ApiResourceManager';

export default class MenuEditHistoryManager extends ApiResourceManager {
  // Paginated, filterable audit log of price/availability/visibility changes to
  // the selected company's products and modifiers (super-admin only). The company
  // is carried by the x-on-behalf-of-company header.
  get = (params) =>
    this.request({
      method: 'GET',
      url: '/menu-edit-history',
      params,
      paramsSerializer: qs.stringify,
    });
}
